import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { InjectedTranslateProps, translate } from "react-i18next";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export interface DeleteReservationDialogProps {
	peopleCount: number;
	primaryName: string;
	open: boolean;
	onYes: () => void;
	onNo: () => void;
}

interface ConnectedDeleteReservationDialogProps
	extends WithStyles<typeof styles> {}

type Props = DeleteReservationDialogProps &
	ConnectedDeleteReservationDialogProps &
	InjectedTranslateProps;

export class DeleteReservationDialog extends React.Component<Props, {}> {
	handleNoClick = () => {
		this.props.onNo();
	};

	handleYesClick = () => {
		this.props.onYes();
	};

	render() {
		const { classes, open, peopleCount, primaryName } = this.props;

		return (
			<Dialog open={open}>
				<DialogTitle>Reservierung löschen</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Soll die Reservierung{" "}
						<strong>
							{peopleCount}
							&nbsp;
							{peopleCount > 1 ? "Personen" : "Person"}
							&nbsp;-&nbsp;
							{primaryName}
						</strong>{" "}
						tatsächlich gelöscht werden?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						className={classes.cancelButton}
						onClick={this.handleNoClick}
						autoFocus={true}
					>
						Nein
					</Button>
					<Button
						className={classes.submitButton}
						onClick={this.handleYesClick}
						color="primary"
					>
						Ja
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

const styles = (theme: Theme) =>
	createStyles({
		cancelButton: {},
		submitButton: {}
	});

export const ConnectedDeleteReservationDialog = translate("translations")(
	withStyles(styles)(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(DeleteReservationDialog)
	)
);
